/** Normaliza chave de assunto (espelho do backend). */
export function normalizeAssuntoKey(value: string): string {
  return value.trim().toLocaleLowerCase('pt-BR');
}
